import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns): string => {
	const timestamp = item?.executingStages?.with_clients?.timestamp;
	if (!timestamp || !dateFns) return "";
	return dateFns.formatTime(timestamp, {
		isTimezone: true,
		formatTime: "HH:mm:ss",
	});
};

export default cellProcessing;
